type Context = 'agent';

type Section =
  | 'account-intel'
  | 'sub-agents-list' // master sub-agents list
  | 'questions'
  | 'personalise-research'
  | 'update-config-questions'
  | 'customer-sub-agents'
  | 'simple-research-questions';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  'account-intel': 'agent-account-intel',
  'sub-agents-list': 'agent-sub-agents-list',
  questions: 'agent-questions',
  'personalise-research': 'agent-personalise-research',
  'update-config-questions': 'agent-update-config-questions',
  'customer-sub-agents': 'agent-customer-sub-agents',
  'simple-research-questions': 'agent-simple-research-questions',
};
